import { __ } from '@wordpress/i18n';
/**
 * Handles the confirmation of card payments (3DSv2 modals/SCA challenge).
 *
 * @param {Object}   paymentDetails    Details about the payment, received from the server.
 * @param {Object}   emitResponse      Various helpers for usage with observer response objects.
 * @return {Object}                An object, which contains the result from the action.
 */
export const confirmSwishPayment = async (
	paymentDetails,
	setIsModalOpen,
	setQrCodeData,
	setSwishToken,
	setSwishLink,
	emitResponse
) => {

	const swish_qr = paymentDetails.swish_qr;
	const swish_token = paymentDetails.swish_token;
	const swish_link = paymentDetails.swish_link;
	const statusUrl = paymentDetails.status_endpoint;
	console.log('paymentDetails:', paymentDetails);
	// Show Modal
	setQrCodeData(swish_qr);
	setSwishToken(swish_token);
	setSwishLink(swish_link);
	setIsModalOpen(true);
	
	let status = 'pending';
	while (status === 'pending') {
		try {
			const response = await fetch(statusUrl);
			const data = await response.json();
	
			if (data.result === 'success') {
				return { 
					status: 'success', 
					redirectUrl: data.redirect 
				};

			} else if (data.result === 'error') {
				status = 'error';
				setIsModalOpen(false);
				throw new Error(__('Payment failed', 'woocommerce-gateway-swish-ecommerce'));
			}else {
				// If status is pending, wait for 2 seconds before the next fetch
				await new Promise(resolve => setTimeout(resolve, 2000));
			}
		} catch (error) {
			console.error('Error:', error);
			return {
				type: 'error',
				message: error.message,
				messageContext: emitResponse.noticeContexts.PAYMENTS,
			};
		}
	}
};
